module.exports = new __parcel__URL__("presence-spotlight-img.518d169f.png").toString();